import skillsDecoderSvg from '@h2/assets/svg/blockGraphics/skillsDecoder.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const BlankCard = ({ nextStep }) => {
  return (
    <Promotion color="orange" variant="continue">
      <Promotion.PreHeading>
        {nextStep.nonTemplateDetails.preHeading}
      </Promotion.PreHeading>
      <Promotion.Heading>{nextStep.nonTemplateDetails.heading}</Promotion.Heading>
      <Promotion.Text>{nextStep.nonTemplateDetails.body}</Promotion.Text>
      <Promotion.Button href={nextStep.nonTemplateDetails.url}>
        {nextStep.nonTemplateDetails.buttonTitle}
      </Promotion.Button>
      <Promotion.Image src={skillsDecoderSvg} />
    </Promotion>
  )
}

export { BlankCard }
